import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getUserIsAuthenticated } from '~/selectors/user.selectors';

import { QUERY_KEY } from '../constants/cacheKeys.const';
import { STABLE_QZ_QUERY_SETTINGS } from '../constants/qzQuery.const';
import { listWorkstations } from '../services/workstation.service';
import { type Workstation } from '../types/print.type';

const EMPTY_WORKSTATIONS: Workstation[] = [];

// The query is ungated beyond auth on purpose. A route gate or a persisted flag left
// usePrinterConfig reporting "no workstation" outside the print pages, which is what hid
// Shippo Print in an incognito session. STABLE_QZ_QUERY_SETTINGS caps the cost at one request
// per tab session.
export const useWorkstations = () => {
  const isAuthenticated = useSelector(getUserIsAuthenticated);

  const query = useQuery({
    enabled: isAuthenticated,
    queryFn: listWorkstations,
    queryKey: QUERY_KEY.useWorkstations,
    select: (response) => response.workstations,
    ...STABLE_QZ_QUERY_SETTINGS,
  });

  return { query, workstations: query.data ?? EMPTY_WORKSTATIONS };
};
